export default "__VITE_ASSET__CRW4H990__"